<template>
  <!-- 收集手机号码 -->
  <div v-if="show&&user.id&&!user.mobile">
    <div class="mask" @touchmove="preventDefault($event)"></div>
    <div class="step-wrap" :class="{'step-0': step === 0, 'step-1': step === 1}">
      <div class="step0" v-if="step === 0">
        <div class="bg">
          <img src="@/common/image/phone-vip-bg.png" alt="">
          <div class="title"><span>3<span>日 </span></span>会员体验券</div>
          <div class="sub-title">绑定手机领取会员卡</div>
          <div class="input-wrap">
            <input type="number" placeholder="请输入手机号" v-model="phone">
          </div>
          <div class="tips">领取后马上生效，2000+课程免费看</div>
          <img src="@/common/image/close.png" alt="" class="close" @click="close">
        </div>
        <div class="btn" @click="send">立即领取</div>
      </div>
      <div class="step1" v-if="step === 1">
        <div class="con">
          <img src="@/common/image/close.png" alt="" class="close" @click="close">
          <img src="@/common/image/back.png" alt="" class="back" @click="back">
          <div class="title">请输入验证码</div>
          <div>
            <input type="number" v-model="code" placeholder="请输入">
          </div>
          <div class="tips">领取后马上生效，2000+课程免费看</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {sendCode, verifyCode} from '@/api/activity/bindphone'
let isPopup = false
export default {
  data() {
    return {
      show: !isPopup,
      step: 0, // 0 输入手机号码, 1 已经发送验证码，输入验证码
      phone: '',
      lastphone: '', // 防止用户不小心后退了
      code: '',
      timer: null
    }
  },
  created() {
    isPopup = true
  },
  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    code(v) {
      if (v && v.length === 4) {
        console.log(v)
        // 调接口验证
        verifyCode(this.phone, this.code).then(({data}) => {
          if (data && data.code === 1) {
            this.$toast('3日会员已领取成功')
            this.close()
          } else {
            this.$toast((data && data.msg) || '验证失败')
          }
        })
      }
    }
  },
  methods: {
    preventDefault(event) {
      event.preventDefault()
      event.stopPropagation()
    },
    close() {
      this.show = false
    },
    back() {
      this.step = 0
      // 后退清除验证码
      this.code = ''
    },
    send() {
      console.log(this.phone)
      if (!/^1[\d]{10}$/g.test(this.phone)) {
        this.$toast('请输入正确的手机号码')
      } else if (this.timer) {
        // 已经发送
        if (this.phone === this.lastphone) {
          // 没有改手机号码, 继续输入验证码
          this.step = 1
        } else {
          // 改了手机号码，又在等待30s中
          this.$toast('操作频繁')
        }
      } else {
        sendCode(this.phone).then(({data}) => {
          if (data && data.code === 1) {
            this.wait()
            this.$toast('发送成功')
            this.lastphone = this.phone
            this.step = 1
          } else {
            this.$toast((data && data.msg) || '发送失败')
          }
        })
      }
    },
    wait() {
      // 发送验证码等待
      const all = 30 // 30s
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.timer = null
      }, all * 1000)
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  $height = 532
  $width = 630
  .mask
    position fixed
    left 0
    top 0
    bottom 0
    right 0
    background rgba(0,0,0,.4)
    z-index 999
  .step-wrap
    position fixed
    top 0
    left 0
    top 50%
    transform translateY(-50%)
    width 100%
    z-index 9999
  .close
    position absolute
    width size(60)!important
    right size(30)
    top size(-(70+60))
  .back
    position absolute
    left size(26)
    top size(20)
    width size(14)
  .step0
    .bg
      margin 0 size(60)
      position relative
      text-align center
      min-height size(500)
      img
        display block
        width 100%
      >div
        position absolute
        width 100%
        left 0
      .title
        color #fc3803
        top 6%
        font-weight 800
        font-size size(42)
        >span
          font-size size(70)
          >span
           font-size size(32)
      .sub-title
        color #fff
        font-size size(30)
        top percentage(292/$height)
      .input-wrap
        top percentage(352/$height)
        input
          font-size size(32)
          text-align center
          border-radius 2px
          width percentage(390/$width)
          height size(30)
          line-height size(30)
          padding size(20) size(16)
          box-shadow inset 0 0 1px 1px rgba(0,0,0,.3)
          color #a7a7a7
          box-sizing content-box
          &::-webkit-input-placeholder
            line-height 1.2
      .tips
        top percentage(448/$height)
        color #ffffff
        font-size size(28)
    .btn
      margin size(56) auto
      text-align center
      color rgb(192,14,43)
      line-height size(76)
      font-size size(36)
      width size(344)
      height size(76)
      border-radius size(38)
      background-color #ffd84a
      background linear-gradient(to bottom, rgb(255,242,100), rgb(255,195,52))
      box-shadow 0 1px 2px 1px rgba(0,0,0, .5)
  .step1
    .con
      color #ffffff
      text-align center
      position relative
      margin 0 size(60)
      min-height size(335)
      border-radius size(22)
      background linear-gradient(to bottom, rgb(255,104,66), rgb(254,55,78))
      .title
        font-size size(30)
        padding size(50) 0
      input
        box-sizing content-box
        width size(190)
        background none
        padding size(10) size(16)
        font-size size(44)
        // color #b41500
        color #fff
        border-bottom 1px solid #e3331c
        letter-spacing size(18)
        outline none
        &::-webkit-input-placeholder
          font-size size(40)
          color #fff
          text-align center
      .tips
        font-size size(26)
        margin-top size(56)
</style>



// WEBPACK FOOTER //
// src/components/base/activity/bindphone/index.vue